const initialState = {
    activeMarket: JSON.parse(localStorage.getItem('activeMarket')) !== null ? JSON.parse(localStorage.getItem('activeMarket')) : '',
    listMarkets: [],
    loaderSelectedMarket:false,
};
const markets = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_LIST_MARKETS':
            return {...state, listMarkets:  action.listMarkets};
        case 'CHANGE_SET_ACTIVE_MARKET':
            localStorage.setItem('activeMarket', JSON.stringify(action.activeMarket));
            return {...state, activeMarket:  action.activeMarket};
            case 'CHANGE_LOADER_SELECTED_ACTIVE_MARKET':
            return {...state, loaderSelectedMarket:  action.loaderSelectedMarket};
        default:
            return state;
    }
};

export default markets;
